<template>
  <router-view/>
</template>

<style>
html {
  background-color: #f2f2f2;
}

#app {
  min-height: 100vh;
  margin: 0 auto !important;
  max-width: 500px !important;
  position: relative;
  background-color: #f8f9fa;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  overflow-x: hidden;
}
</style>
